var exports = {
  "Vg": "ChatSkeleton.module__grid___d19rZk",
  "wx": "ChatSkeleton.module__header___d19rZk",
  "D_": "ChatSkeleton.module__identity___d19rZk",
  "Ow": "ChatSkeleton.module__identityBack___d19rZk",
  "um": "ChatSkeleton.module__identityBackDesktop___d19rZk",
  "W": "ChatSkeleton.module__identityName___d19rZk",
  "aL": "ChatSkeleton.module__identityCaret___d19rZk",
  "lf": "ChatSkeleton.module__identityTopicDivider___d19rZk",
  "$s": "ChatSkeleton.module__headerActions___d19rZk",
  "QE": "ChatSkeleton.module__headerAction___d19rZk",
  "YB": "ChatSkeleton.module__headerSearch___d19rZk",
  "lQ": "ChatSkeleton.module__headerSearchIcon___d19rZk",
  "Qs": "ChatSkeleton.module__content___d19rZk",
  "ec": "ChatSkeleton.module__memberListDivider___d19rZk",
  "oM": "ChatSkeleton.module__chatArea___d19rZk",
  "JX": "ChatSkeleton.module__chatBody___d19rZk",
  "DZ": "ChatSkeleton.module__messages___d19rZk",
  "T_": "ChatSkeleton.module__composerInputLine___d19rZk",
  "PN": "ChatSkeleton.module__composerAction___d19rZk",
  "JD": "ChatSkeleton.module__memberList___d19rZk",
  "Pz": "ChatSkeleton.module__memberListScroller___d19rZk",
};

module.exports = exports;
